import { ScrollStrategyOptions } from '@angular/cdk/overlay';
import { DOCUMENT } from '@angular/common';
import { HTTP_INTERCEPTORS, } from '@angular/common/http';
import { ErrorHandler, } from '@angular/core';
import { ErrorStateMatcher, MAT_LABEL_GLOBAL_OPTIONS, MAT_RIPPLE_GLOBAL_OPTIONS, } from '@angular/material/core';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { AppStateFacade, Setting, } from '@app-state';
import { AppRippleOptions, } from '@app/main.component';
import { COLOR_PROVIDER } from '@components/ui-chart/chart-color-provider';
import { DATA_MATRIX_BACKGROUND_COLOR_RESOLVER } from '@components/ui-data-matrix/ui-data-matrix.component';
import { UiAutocompleteIntl, UiMatDatepickerIntl, UiMatPaginatorIntl, UiSnackIntl, UiTableIntl, } from '@intl';
import { TranslateService, } from '@ngx-translate/core';
import { ColorService, Logger, LoggerFactory, } from '@services';
import { ThemeColorProvider } from '@services/color/color.provider';
import { HttpEmptyInterceptor } from '@services/generics/http.empty.intercept';
import { Interceptor, INTERCEPTOR_DEPENDENCIES, } from '@services/generics/http.intercept';
import { HttpMaintenanceInterceptor } from '@services/generics/http.maintenance.intercept';
import { UiGridIntl } from '@uipath/angular/components/ui-grid';
import { UiSnackbarIntl } from '@uipath/angular/components/ui-snackbar';
import { UiSuggestIntl } from '@uipath/angular/components/ui-suggest';
import { UI_DATEFORMAT_OPTIONS } from '@uipath/angular/directives/ui-dateformat';
import { UI_SECONDFORMAT_OPTIONS } from '@uipath/angular/directives/ui-secondformat';
import { ERROR_HANDLER_DEPENDENCIES, GlobalErrorHandler, } from '@utils/errorHandler/globalErrorHandler';
import { SENTRY_DSN, SENTRY_TRACKED_DOMAINS, } from '@utils/errorHandler/sentryErrorHandler';
import { UiScrollStrategyOptions } from '@utils/scroll-stategy-options';
import { environment } from '../environments/environment';
import { UiErrorStateMatcher } from './validators/error-state-matcher';
var QA_DEV_HOSTNAMES = [
    /qa\.test$/,
    /^devtest-e2e-.*azurewebsites\.net$/,
];
export var GLOBAL_INTERCEPTORS = [{
        provide: HTTP_INTERCEPTORS,
        useClass: HttpEmptyInterceptor,
        multi: true,
    }, {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpMaintenanceInterceptor,
        multi: true,
    }, {
        provide: HTTP_INTERCEPTORS,
        useClass: Interceptor,
        deps: INTERCEPTOR_DEPENDENCIES,
        multi: true,
    }];
var ɵ0 = environment.production ? [
    /platform\.uipath\.com$/,
    /deskover\.local$/
].concat(QA_DEV_HOSTNAMES) :
    [], ɵ1 = function (_document) {
    if (!environment.production) {
        return 'https://6c326249aa8842179f59905f237436ea@sentry.io/1372845';
    }
    if (QA_DEV_HOSTNAMES.some(function (reg) { return reg.test(_document.location.hostname); })) {
        return 'https://6529911c060f4ab08a17355bbe062282@sentry.io/1387287';
    }
    return 'https://93064310bfe14da7b6446725f524283c@sentry.io/1372840';
}, ɵ2 = {
    float: 'always',
}, ɵ3 = {
    animationDuration: '0ms',
}, ɵ4 = {
    showDelay: 300,
}, ɵ5 = function (color) { return function () { return color.theme.material.background.card; }; }, ɵ6 = function (appState) { return ({
    timezone: function () { return appState.settings.get(Setting.timezone) || 'Etc/UTC'; },
    redraw$: appState.language.change$,
}); }, ɵ7 = function (appState) { return ({
    redraw$: appState.language.change$,
}); }, ɵ8 = {
    strokeWidth: 5,
};
var PROVIDERS = GLOBAL_INTERCEPTORS.concat([{
        provide: ErrorHandler,
        useClass: GlobalErrorHandler,
        deps: ERROR_HANDLER_DEPENDENCIES,
    }, {
        provide: SENTRY_TRACKED_DOMAINS,
        useValue: ɵ0,
    }, {
        provide: SENTRY_DSN,
        useFactory: ɵ1,
        deps: [DOCUMENT],
    }, {
        provide: MAT_RIPPLE_GLOBAL_OPTIONS,
        useExisting: AppRippleOptions,
    }, {
        provide: MAT_LABEL_GLOBAL_OPTIONS,
        useValue: ɵ2,
    }, {
        provide: MAT_TABS_CONFIG,
        useValue: ɵ3,
    }, {
        provide: MAT_TOOLTIP_DEFAULT_OPTIONS,
        useValue: ɵ4,
    }, {
        provide: Logger,
        useClass: LoggerFactory({
            production: environment.production,
        }),
        multi: false,
    }, {
        provide: ErrorStateMatcher,
        useClass: UiErrorStateMatcher,
    }, {
        provide: MatDatepickerIntl,
        useClass: UiMatDatepickerIntl,
        deps: [TranslateService, AppStateFacade],
    }, {
        provide: UiSuggestIntl,
        useClass: UiAutocompleteIntl,
        deps: [TranslateService],
    }, {
        provide: UiSnackbarIntl,
        useClass: UiSnackIntl,
        deps: [TranslateService],
    }, {
        provide: UiGridIntl,
        useClass: UiTableIntl,
        deps: [TranslateService, AppStateFacade],
    }, {
        provide: MatPaginatorIntl,
        useClass: UiMatPaginatorIntl,
        deps: [TranslateService, AppStateFacade],
    }, {
        provide: COLOR_PROVIDER,
        useClass: ThemeColorProvider,
    }, {
        provide: DATA_MATRIX_BACKGROUND_COLOR_RESOLVER,
        useFactory: ɵ5,
        deps: [ColorService],
    }, {
        provide: UI_DATEFORMAT_OPTIONS,
        useFactory: ɵ6,
        deps: [AppStateFacade],
    }, {
        provide: UI_SECONDFORMAT_OPTIONS,
        useFactory: ɵ7,
        deps: [AppStateFacade],
    }, {
        provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
        useValue: ɵ8,
    }, {
        provide: ScrollStrategyOptions,
        useClass: UiScrollStrategyOptions,
    }]);
var AppModule = /** @class */ (function () {
    function AppModule(logger) {
        var workerScript = 'ngsw-worker.js';
        var isServiceWorkerEnabled = 'serviceWorker' in navigator && environment.production;
        if (!isServiceWorkerEnabled) {
            return;
        }
        navigator.serviceWorker
            .getRegistration(workerScript)
            .then(function (worker) {
            if (!!worker) {
                return;
            }
            navigator.serviceWorker
                .register(workerScript)
                .then(function () { return logger.log('Service Worker Successfully registered'); })
                .catch(function () { return logger.warn('Service Worker did not register'); });
        })
            .catch(function (e) { return logger.error(e); });
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8 };
